import get from 'lodash/get'

export const BASE_URL = 'https://reden.me'

export const getChatUrlByRoomId = roomId =>
  `${get(global, 'location.origin') || BASE_URL}/chats/${roomId}`
